/** מספר לקבלת תשלום באפליקציית ביט */
export const ACADEMY_BIT_PAYMENT_PHONE = '+972537411456';

export const ACADEMY_BIT_PAYMENT_PHONE_DISPLAY = '053-741-1456';
